module.exports = __webpack_public_path__ + "assets/img/offline-coupon1.e993c794.png";